import { useTranslation } from 'react-i18next';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { DispatchPanel } from '../ops/DispatchPanel';
import { EntryPanel } from '../ops/EntryPanel';
import { useLoad } from '../lib/useAsync';

function useDistributor(): number | null {
  const { user } = useAuth();
  return (user?.locations ?? []).find((l) => l.can_distribute && l.type === 'STORE')?.id ?? null;
}

/** Entrada propia de la ubicación distribuidora (hoy Masters 85): prendas terminadas que llegan de talleres externos. */
export function MasterEntry() {
  return <EntryPanel own locationId={useDistributor()} onDone={() => undefined} />;
}

/** Distribución desde la ubicación distribuidora hacia los demás locales. */
export function MasterDispatch() {
  const { t } = useTranslation();
  const origin = useDistributor();
  const locations = useLoad(() => api.locations(), []);
  return (
    <DispatchPanel
      idPrefix="masterDispatch" originId={origin} destinations={locations.data ?? []} onDispatched={() => undefined}
      header={<><h2>{t('master.dispatchHeading')}</h2><p>{t('master.dispatchHelp')}</p></>}
    />
  );
}
